import { useState } from "react";
import clsx from "clsx";
import { Tabs } from "components";
import logo from "assets/artists4people/artists4-logo.png";
import * as pages from "./components";
import { Link } from "react-router-dom";

const tabs = [
  { id: "Concert", display: "concert" },
  { id: "Performers", display: "Apply" },
  { id: "Contact", display: "Contact" },
  { id: "Support", display: "Support" },
];

export default function ArtistsForProple() {
  const [selectedTab, setTab] = useState(tabs[0]);
  const tabsProps = {
    tabs,
    selectedTab: selectedTab.id,
    setTab,
    id: "events",
  };
  return (
    <div className={parentContainer}>
      <div className="lg:w-[800px] flex-col flex justify-center items-center">
        <Link to='/artistsforpeople' className={logoContainer}>
          <div className="z-[5] bg-red h-40 w-40 rounded-full absolute"></div>
          <img
            src={logo}
            alt="text that says artists for people (logo)"
            className="z-[10] absolute"
          />
        </Link>
        <Tabs {...tabsProps} />
        <div className={wrapper}>
          {selectedTab.id === tabs[0].id && <pages.About />}
          {selectedTab.id === tabs[1].id && <pages.Performers />}
          {selectedTab.id === tabs[2].id && <pages.Contact />}
          {selectedTab.id === tabs[3].id && <pages.Support />}
        </div>
      </div>
    </div>
  );
}

const parentContainer = clsx(
  "h-full flex flex-col items-center bg-[#fffbf5] w-full"
);
const logoContainer = clsx(
  "w-[300px] h-[150px] mt-10 relative justify-center flex items-center"
);
const wrapper = clsx("flex flex-wrap w-full justify-around items-start mt-10 px-10 lg:px-0");
